export default () => {

  const runMode = ignite.getRunMode();

  switch(runMode) {
    case 'production':
      return {
				cognitoUrl: 'https://commerce-480621733616.auth.us-east-1.amazoncognito.com/oauth2/token',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Authorization': 'Basic ZDFtcGQ5ZjA5czQzNnZvc2VtMGoyMWgxbzozMzlxczc0M2hjNm44aW9jdWFsdmsyZjBqMGdsN3VjZHNldWltbmZzcDZvYThlZjBnaGk='
				},
				body: new URLSearchParams({
					grant_type: 'client_credentials',
					scope: 'dialogue-commerce-prod/reporting'
				}),
        salesforceUrl: 'https://commerce.dialogue.api.moneymatch.net/lead-processor/run',
			}
    case 'pilot':
      return {
				cognitoUrl: 'https://dev-480621733616.auth.us-east-1.amazoncognito.com/oauth2/token',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Authorization': 'Basic NWhpdTNnZWJxYWV2cWVlNGk0a29kMmtqZDE6a251c3VsYmJvN3ZuMWkwcDA2aW9yZG11NW9vcWZnN3NocWtzM2s4MnUzZDhlbzVoNmlk'
				},
				body: new URLSearchParams({
					grant_type: 'client_credentials',
					scope: 'dialogue-dev-prod/reporting'
				}),
        salesforceUrl: 'https://pipeline-commerce-qa.dialogue.api.moneymatch.net/lead-processor/run',
			}
    case 'staging':
    default:
      return {
				cognitoUrl: 'https://dev-480621733616.auth.us-east-1.amazoncognito.com/oauth2/token',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Authorization': 'Basic NWhpdTNnZWJxYWV2cWVlNGk0a29kMmtqZDE6a251c3VsYmJvN3ZuMWkwcDA2aW9yZG11NW9vcWZnN3NocWtzM2s4MnUzZDhlbzVoNmlk'
				},
				body: new URLSearchParams({
					grant_type: 'client_credentials',
					scope: 'dialogue-dev-prod/reporting'
				}),
        salesforceUrl: 'https://pipeline-dialogue-774.dialogue.api.moneymatch.net/lead-processor/run',
			}
  }

}